import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-generate-insights-modal',
  templateUrl: './generate-insights-modal.component.html',
  styleUrls: ['./generate-insights-modal.component.scss'],
})
export class GenerateInsightsModalComponent {
  @Input() isProcessing: boolean = false;
  @Output() proceed = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onProceed(): void {
    if (!this.isProcessing) {
      this.proceed.emit();
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
